import type {
  UseFormSetValue,
  UseFormResetField,
  FieldValues,
} from 'react-hook-form';
import type { FieldConfig } from 'containers/admin/clients/client/tabs-components/goals-tab/goals-manager/goal/goal-form/hooks/useGenerateFields';

export interface HandleSelectChangeArg {
  value: unknown;
  field: FieldConfig;
  onChange: (value: unknown) => void;
  index: number;
  detailIndex?: number;
}

export type HandleSelectChange = (arg: HandleSelectChangeArg) => void;

const useHandleSelectChange =
  (
    fields: FieldConfig[],
    setFields: (fields: FieldConfig[]) => void,
    setValue: UseFormSetValue<FieldValues>,
    resetField: UseFormResetField<FieldValues>
  ): HandleSelectChange =>
  ({ value, field, onChange, index, detailIndex = 0 }) => {
    const fieldName = `details.${detailIndex}.${field.associatedPropertyName}`;

    onChange(value);
    setValue(fieldName, value);

    const selectedOption = field.options?.find((opt) => opt.value === value);

    if (selectedOption?.nested) {
      const newFields = [...fields.slice(0, index + 1), selectedOption.nested];

      setFields(newFields);
    }

    fields
      .slice(index + 1)
      .forEach((f) =>
        resetField(`details.${detailIndex}.${f.associatedPropertyName}`)
      );
  };

export default useHandleSelectChange;
